import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { Translate } from "react-redux-i18n";
import { ContentContainer } from "../Common/ContentContainer";
import WizardProgress from "./WizardProgress";
import WizardContent from "./WizardContent";
import { getXsrfToken } from "../../Store/Security/Actions";
import { init, goTo, resetFinish, enableStep, disableStep } from "../../Store/Wizard/Actions";

class Wizard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: props.name,
            totalSteps: props.steps ? props.steps.length : 0,
            startStep: props.startStep || 1,
            steps: _.map(props.steps, (step, i) => {
                step.number = i + 1;
                return step;
            }) || [],
            currentStep: props.startStep || 1,
            stopped: false,
            useReducer: typeof props.useReducer === "boolean" ? props.useReducer : true,
            onStepChanging: props.onStepChanging || this.onStepChanging,
            onStepChanged: props.onStepChanged || this.onStepChanged,
            submitAction: props.submitAction
        };

        this.stop = this.stop.bind(this);
        this.start = this.start.bind(this);
        this.goNext = this.goNext.bind(this);
        this.goPrev = this.goPrev.bind(this);
        this.goFirst = this.goFirst.bind(this);
        this.goLast = this.goLast.bind(this);
        this.goTo = this.goTo.bind(this);
        this.onStepClick = this.onStepClick.bind(this);
        this.enableStep = this.enableStep.bind(this);
        this.disableStep = this.disableStep.bind(this);

        this.onFinishing = this.onFinishing.bind(this);
        this.onFinished = this.onFinished.bind(this);

        if (props.startStep > 1) {
            this.goTo(props.startStep);
        }

        this.props.init(props.name, this.state);
    }

    componentWillReceiveProps(nextProps) {
        const { wizards } = nextProps;

        // Updated Stopped state
        if (wizards[this.state.name] && this.state.stopped !== wizards[this.state.name].stopped) {
            this.setState({ stopped: wizards[this.state.name].stopped });
        }

        // Updated current step
        if (wizards[this.state.name] && this.state.currentStep !== wizards[this.state.name].currentStep) {
            this.setState({ currentStep: wizards[this.state.name].currentStep });
            this.goTo(wizards[this.state.name].currentStep);
        }

        // Finish wizard
        if (wizards[this.state.name] && wizards[this.state.name].finish) {
            this.onFinishing();
        }

        // Update steps
        // - Fix for not skipping step at checkout when "ship to same address" is checked. Was not skipping step.
        // - Only run this logic if the wizard in not the Checkout or Lease wizard.
        // - Without checking "this.state.name !== 'Checkout' && this.state.name !== 'Lease'". It disables the step, then returns the step again without disabling it. Receives disabled=true one step too late.
        // - Still run this logic on wizards other than Checkout or Lease wizards, because they break if this logic is totally removed.
        if (this.state.name !== "Checkout" && this.state.name !== "Lease") {
            if (!_.isEqual(this.props.steps, nextProps.steps)) {
                this.setState({ steps: _.map(nextProps.steps, (step, i) => {
                    step.number = i + 1;
                    return step;
                }) });
            } else if (!_.isEqual(this.props.steps, wizards[this.state.name].steps)) {
                this.setState({ steps: _.map(wizards[this.state.name].steps, (step, i) => {
                    step.number = i + 1;
                    return step;
                }) });
            }
        }
    }

    // region Methods
    stop() {
        this.setState({ stopped: true });
    }

    start() {
        this.setState({ stopped: false });
    }

    goNext() {
        const { currentStep, steps, totalSteps } = this.state;
        let number = totalSteps;

        if (totalSteps >= currentStep + 1) {
            number = currentStep + 1;
        }

        const stepDisabled = steps[number - 1].disabled;

        if (stepDisabled) {
            const availableSteps = _.filter(steps, step => step.number > currentStep && step.number !== number);

            if (availableSteps.length < 1) {
                number = currentStep;
            } else if (availableSteps.length === 1) {
                number = availableSteps[0].number;
            } else {
                number = _.orderBy(availableSteps, "number")[0].number;
            }
        }

        if (number === totalSteps && !steps[number - 1].component) {
            this.onFinishing();
        } else {
            this.goTo(number);
        }
    }

    goPrev() {
        const { currentStep, steps } = this.state;
        let number = 1;

        if (currentStep - 1 >= 1) {
            number = currentStep - 1;
        }

        const stepDisabled = steps[number - 1].disabled;

        if (stepDisabled) {
            const availableSteps = _.filter(steps, step => step.number < currentStep && step.number !== number);

            if (availableSteps.length < 1) {
                number = currentStep;
            } else if (availableSteps.length === 1) {
                number = availableSteps[0].number;
            } else {
                number = _.orderBy(availableSteps, "number", "desc")[0].number;
            }
        }

        this.goTo(number);
    }

    goFirst() {
        this.goTo(1);
    }

    goLast() {
        const { totalSteps } = this.state;
        this.goTo(totalSteps);
    }

    goTo(number) {
        const { onStepChanging, onStepChanged } = this.state;

        onStepChanging(number);
        setTimeout(() => {
            if (this.state.stopped) {
                this.setState({ stopped: false });
            } else {
                this.setState({ currentStep: number });
                this.props.goTo(this.state.name, number);
                setTimeout(() => {
                    onStepChanged(number);
                }, 10);
            }
        }, 10);
    }

    onStepClick(step) {
        const { currentStep, steps } = this.state;
        let number = currentStep;

        if (step < currentStep) {
            number = step;

            const stepDisabled = steps[number - 1].disabled;

            if (stepDisabled) {
                // const availableSteps = _.filter(steps, step => step.number < currentStep && step.number !== number);
                //
                // if (availableSteps.length < 1) {
                //     number = currentStep;
                // } else if (availableSteps.length === 1) {
                //     number = availableSteps[0].number;
                // } else {
                //     number = _.orderBy(availableSteps, "number", "desc")[0].number;
                // }

                number = currentStep
            }
        }

        this.goTo(number);
    }

    enableStep(step) {
        const newSteps = _.map(this.state.steps, (stepObj, i) => {
            if (step - 1 === i) {
                stepObj.number = i + 1;
                stepObj.disabled = false;
                this.props.enableStep(this.state.name, step);
            }

            return stepObj;
        });

        this.setState({ steps: newSteps });
    }

    disableStep(step) {
        const newSteps = _.map(this.state.steps, (stepObj, i) => {
            if (step - 1 === i) {
                stepObj.number = i + 1;
                stepObj.disabled = true;
                this.props.disableStep(this.state.name, step);
            }

            return stepObj;
        });

        this.setState({ steps: newSteps });
    }
    // endregion

    // region Events
    onStepChanging() {
        return false;
    }

    onStepChanged() {
        return false;
    }

    onFinishing(values, timeout) {
        const { onFinishing, getXsrfToken } = this.props;
        const { submitAction } = this.state;

        if (onFinishing && typeof onFinishing === "function") {
            onFinishing(values);
        }

        setTimeout(() => {
            if (this.state.stopped) {
                this.setState({ stopped: false });
            } else if (submitAction && typeof submitAction === "function") {
                if (timeout) {
                    setTimeout(() => {
                        getXsrfToken(({ token }) => {
                            submitAction({ ...values, __RequestVerificationToken: token }, this.onFinished);
                        });
                    }, timeout);
                } else {
                    getXsrfToken(({ token }) => {
                        submitAction({ ...values, __RequestVerificationToken: token }, this.onFinished);
                    });
                }
            } else {
                this.onFinished();
            }
        }, 10);
    }

    onFinished(response) {
        const { onFinished, resetFinish } = this.props;

        resetFinish(this.state.name);

        if (onFinished && typeof onFinished === "function") {
            onFinished(response);
        }
    }
    // endregion

    // region UI
    renderProgressSteps() {
        const { steps, currentStep } = this.state;

        return _.map(steps, step => {
            const className = step.number <= currentStep ? "active" : "";
            const style = step.number < currentStep && !step.disabled ? { cursor: "pointer" } : {};

            return <li key={step.number} className={className} onClick={() => this.onStepClick(step.number)} style={style}>
                <span className="step-number"><Translate value="misc.step" /> {step.number}:</span>
                <p className="step-name"><Translate value={step.name} /></p>
            </li>;
        })
    }

    handleTarget() {
        const { steps, currentStep } = this.state;
        const component = steps[currentStep - 1].component;
        const thisPropsComponent = this.props.steps[currentStep - 1].component;


        if (!_.isEqual(thisPropsComponent.props, component.props) &&
            thisPropsComponent.props.wizardName === component.props.wizardName) {
            return thisPropsComponent;
        }

        return component;
    }
    // endregion

    render() {

        return (
            <ContentContainer>
                <div className="row">
                    <div className="col-md-12">
                        <div className="custom-wizard">
                            <WizardProgress
                                steps={this.renderProgressSteps()}
                            />
                            <WizardContent
                                target={this.handleTarget()}
                                goPrev={this.goPrev}
                                goNext={this.goNext}
                                onFinish={this.onFinishing}
                                enableStep={this.enableStep}
                                disableStep={this.disableStep}
                            />
                        </div>
                    </div>
                </div>
            </ContentContainer>
        );
    }
}

function mapStateToProps(state) {
    return {
        wizards: state.wizards
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        init: init,
        goTo: goTo,
        enableStep: enableStep,
        disableStep: disableStep,

        resetFinish: resetFinish,
        getXsrfToken: getXsrfToken
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Wizard);
